import { IRolesRes } from 'types'
import { baseApi } from './baseApi'
import { t } from 'i18next'

export const rolesAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_roles: builder.query<IRolesRes, void>({
      query: () => ({
        url: '/staff-roles/',
      }),
      providesTags: ['roles'],
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response.map(role => { return {
            id: role.id,
            title: t(`roles.${role.id}`)
          }}),
          count,
          hasMore,
        }
      },
    }),
  }),
})

export const { useGET_rolesQuery } = rolesAPI
